import { render, staticRenderFns } from "./OrderDetailsTab.vue?vue&type=template&id=11c5915f&scoped=true&"
import script from "./OrderDetailsTab.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsTab.vue?vue&type=style&index=0&id=11c5915f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5915f",
  null
  
)

export default component.exports